import React from 'react';
import { IconLock } from '../clientModule/components/SvgIcons';

export default function AccessDenied({ onReturnHome, userRole, requiredPermission }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '420px',
      background: '#fff',
      borderRadius: 16,
      border: '1px solid #fee2e2',
      padding: '48px 24px',
      textAlign: 'center',
      boxShadow: '0 4px 12px rgba(220, 38, 38, 0.05)',
      margin: '20px 0',
    }}>
      <div style={{
        width: 72,
        height: 72,
        borderRadius: '50%',
        background: '#f1f5f9',
        color: '#0f172a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20,
        border: '2px solid #cbd5e1'
      }}>
        <IconLock size={36} />
      </div>

      <span className="chip" style={{ background: '#f1f5f9', color: '#0f172a', fontWeight: 800, textTransform: 'uppercase', marginBottom: 12, padding: '4px 12px' }}>
        403 Access Denied
      </span>

      <h2 style={{ margin: '0 0 8px', color: '#0f172a', fontSize: '1.5rem', fontWeight: 800 }}>
        You do not have permission to access this page
      </h2>

      <p style={{ margin: '0 0 24px', color: '#64748b', maxWidth: 460, fontSize: '0.92rem', lineHeight: 1.5 }}>
        Your assigned role <strong style={{ color: '#0f172a' }}>({userRole || 'Staff'})</strong> lacks the required permission {requiredPermission ? <code style={{ background: '#f1f5f9', padding: '2px 6px', borderRadius: 4, color: '#0f172a' }}>{requiredPermission}</code> : 'to view this module'}. Contact your System Administrator to request access.
      </p>

      <button
        onClick={onReturnHome}
        className="cm-btn-emerald"
        style={{ padding: '10px 24px', fontSize: '0.9rem', fontWeight: 800 }}
      >
        ← Return to Allowed Dashboard
      </button>
    </div>
  );
}
